import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { Subscription } from 'rxjs';

export const LoadingStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withDevtools('router-state'),
  withState<{ isLoading: boolean }>({ isLoading: false }),
  withMethods((store) => ({
    setLoading(): void {
      patchState(store, { isLoading: true });
    },
    setCompleted(): void {
      patchState(store, { isLoading: false });
    },
  })),
  withHooks((store, router = inject(Router)) => {
    const subscription = new Subscription();

    const onInit = (): void => {
      subscription.add(
        router.events.subscribe((event) => {
          switch (true) {
            case event instanceof NavigationStart: {
              store.setLoading();
              break;
            }
            case event instanceof NavigationEnd:
            case event instanceof NavigationCancel:
            case event instanceof NavigationError: {
              store.setCompleted();

              break;
            }
            default: {
              break;
            }
          }
        })
      );
    };

    const onDestroy = (): void => {
      subscription.unsubscribe();
    };

    return {
      onInit,
      onDestroy,
    };
  })
);
